import {FormikTextInput} from '@shipwell/shipwell-ui';
import {Field} from 'formik';

const InvoiceNumberField = () => {
  return <Field required label="Invoice #" name="invoice_number" component={FormikTextInput} />;
};
export default InvoiceNumberField;
